export enum PAYMENT_TYPE {
  CREDIT = 'credit',
  CREDIT_CARD = 'credit_card',
  DEBIT = 'debit',
  PREPAID = 'prepaid',
  EXTERNAL = 'external',
  APPLE_PAY = 'apple_pay',
  GOOGLE_PAY = 'google_pay',
}
